ul-breadcrumbs-type-1 {
  .ul-breadcrumbs-type-1 {
    background-color: transparent;

    &__list {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: calc(var(--spacing-2xs) / 1.25);
    }

    &__item {
      display: flex;
      align-items: center;
      gap: calc(var(--spacing-2xs) * 1.2);

      &:last-child {
        .ul-breadcrumbs-type-1__separator {
          display: none;
        }
      }

      // Strip underline from any anchors rendered inside an item, including
      // auto-detected links (e.g. tel: links generated from label text).
      a {
        text-decoration-line: none;
      }
    }

    &__link,
    &__text {
      @include text-style('sm', 'md');

      text-decoration: none;
      transition: color 0.2s ease;
    }

    &__link {
      color: $color-neutral-white;

      &:hover {
        color: var(--color-brand-primary);
      }
    }

    &__text {
      color: rgb(255 255 255 / 70%);
      font-weight: map-get($font-weights, 'normal');
    }

    &__item--current &__text {
      color: rgb(255 255 255 / 70%);
      font-weight: map-get($font-weights, 'normal');
      text-decoration: none;
    }

    &__separator {
      display: flex;
      align-items: center;
      margin-top: 3px;

      .me-icon {
        @include size(16px);

        svg {
          fill: $color-neutral-white;
        }
      }
    }
  }

  // Was `.me-section` — this block renders its own section now, so the background hook
  // follows the rename. Still the full-bleed element: the width clamp lives on __container.
  .ul-breadcrumbs-type-1__section {
    width: 100%;
    background-color: var(--color-surface-dark);
  }

  // Replaces the me-container me-section used to nest inside. y-gap-sm and y-gap-lg-sm
  // both resolve to var(--spacing-sm), so a single padding-block covers both breakpoints.
  // No uslegal theme override exists for container width, so this lands on the 1440px default.
  .ul-breadcrumbs-type-1__container {
    margin-inline: auto;
    padding-block: var(--spacing-sm);
    padding-inline: var(--spacing-md);
    max-width: var(--me-container-max-width, #{$media-desktop});
  }
}
